let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1opcg")).then(() => parcelRequire('8LFOm'));